export default __webpack_public_path__ + "static/media/Nunito-ExtraBold.99f1fa27.ttf";